// src/App.js
import React, { useEffect, useState } from "react";
import { requestNotificationPermission, listenForMessages } from "./utils/notifications";
import AppRouter from "./Router";
import { LanguageProvider } from "./contexts/LanguageContext";
import { GoogleMapsProvider } from "./components/GoogleMapsProvider";
import ErrorBoundary from "./components/ErrorBoundary";
import SplashScreen from "./components/SplashScreen";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import 'leaflet/dist/leaflet.css';
import "./App.css";

const App = () => {
  const [appReady, setAppReady] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const setupNotifications = async () => {
      try {
        // محاولة طلب إذن الإشعارات
        await requestNotificationPermission();
        
        // محاولة الاستماع للإشعارات - في حالة فشل ذلك، سيتم التقاط الخطأ في blcok الـ try/catch
        listenForMessages();
        
        console.log("✅ تم إعداد الإشعارات بنجاح");
        return true;
      } catch (error) {
        console.error("❌ خطأ في إعداد الإشعارات:", error);
        // نعيد true لأن هذا ليس سببًا كافيًا لمنع تحميل التطبيق
        return true;
      }
    };

    const initializeApp = async () => {
      try {
        // محاولة إعداد الإشعارات ولكن استمرار التطبيق حتى في حالة الفشل
        await setupNotifications().catch(err => {
          console.error("❌ فشل تهيئة الإشعارات، سيتم متابعة تحميل التطبيق:", err);
          return true;
        });
        
        // Always show splash screen for at least 3 seconds
        setTimeout(() => {
          setAppReady(true);
          setLoading(false);
        }, 3000);
        console.log("✅ تم تهيئة التطبيق بنجاح");
      } catch (error) {
        console.error("❌ خطأ في تهيئة التطبيق:", error);
        setTimeout(() => {
          setAppReady(true);
          setLoading(false);
        }, 3000);
      }
    };

    initializeApp();
  }, []);

  if (!appReady || loading) {
    return <SplashScreen />;
  }

  return (
    <ErrorBoundary>
      <LanguageProvider>
        <GoogleMapsProvider>
          <div className="app-container">
            <AppRouter />
            <ToastContainer
              position="top-center"
              autoClose={3000}
              rtl={localStorage.getItem('language') !== 'en'}
              hideProgressBar={false}
              newestOnTop
              closeOnClick
              pauseOnFocusLoss
              draggable
              pauseOnHover
              theme="light"
            />
          </div>
        </GoogleMapsProvider>
      </LanguageProvider>
    </ErrorBoundary>
  );
};

export default App;
